(() => {
  const initialize = (section) => {
    if (window.theme?.settings?.enableAjaxFilter === false) return;
    if (!section || section.dataset.ajaxInitialized === 'true') return;
    section.dataset.ajaxInitialized = 'true';
    const fetchSection = async (url, updateHistory = true) => {
      section.classList.add('is-loading');
      const target = new URL(url, location.origin);
      target.searchParams.set('section_id', section.dataset.sectionId);
      try {
        const text = await fetch(target.toString()).then((response) => response.text());
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const replacement = doc.querySelector('[data-ajax-section]');
        if (replacement) {
          section.replaceWith(replacement);
          if (updateHistory) { target.searchParams.delete('section_id'); history.pushState({}, '', `${target.pathname}?${target.searchParams.toString()}`); }
          initialize(replacement);
          window.initProductRoots?.(replacement);
          document.dispatchEvent(new CustomEvent('theme:section-rendered', { detail: { section: replacement } }));
        }
      } finally { section.classList.remove('is-loading'); }
    };
    const form = section.querySelector('[data-facets-form]');
    let timer;
    form?.addEventListener('change', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const params = new URLSearchParams(new FormData(form));
        fetchSection(`${location.pathname}?${params.toString()}`);
      }, 250);
    });
    section.querySelector('[data-sort-by]')?.addEventListener('change', (event) => {
      const params = new URLSearchParams(location.search); params.set('sort_by', event.target.value); fetchSection(`${location.pathname}?${params.toString()}`);
    });
    section.addEventListener('click', (event) => {
      if (event.target.closest('[data-filter-drawer-open]')) section.querySelector('[data-filter-drawer]')?.classList.add('is-open');
      if (event.target.closest('[data-filter-drawer-close]')) section.querySelector('[data-filter-drawer]')?.classList.remove('is-open');
      const link = event.target.closest('.active-filters a,.pagination a');
      if (link) { event.preventDefault(); fetchSection(link.href); }
    });
  };
  document.querySelectorAll('[data-ajax-section]').forEach(initialize);
  addEventListener('popstate', () => location.reload());
})();
